module.exports = __webpack_public_path__ + "media/stitched-amph.8156d0d7.mp4";